<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="magazinesIndustrialLoading">
          <v-toolbar color="primary" dark>
            Industrial Magazines
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
              </template>
              <p>
                ToolTip!
              </p>
            </v-tooltip>-->
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              prepend-icon="mdi-magnify"
              clearable
              v-on:input="onQuickFilterChanged()"
            ></v-text-field> -->
            <v-btn
              class="btn"
              @click="newMagazinesDialog = true"
              outlined
              color="white"
            >
              <v-icon>mdi-plus</v-icon> New
            </v-btn>
          </v-toolbar>
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeploymentDialog = true" /> -->
          <v-card-text v-if="magazinesIndustrial">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-for="mag in magazinesIndustrial"
                :key="mag.id"
              >
                <v-card class="mx-auto">
                  <v-img
                    class="white--text align-end"
                    height="300px"
                    :src="`https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/MagazineAssets/${mag.id}-Thumbnail.${mag.imageExt}?cb=${cb}`"
                  >
                    <v-chip
                      class="ma-2"
                      :color="magStatusColor(mag.status)"
                      dark
                      label
                    >
                      {{ mag.status }}
                    </v-chip>
                  </v-img>

                  <v-card-subtitle class="pb-0">
                    {{ mag.name }}
                  </v-card-subtitle>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="editDetails(mag)" text color="primary">
                      Edit
                    </v-btn>

                    <v-btn
                      text
                      @click="switchStatus(mag)"
                      :color="magazineCardBtnColor(mag.status)"
                      :loading="switchStatusLoading == mag.id"
                    >
                      {{ magazineCardBtnText(mag.status) }}
                    </v-btn>
                    <v-btn
                      icon
                      @click="deleteMagazine(mag.id)"
                      color="red"
                      :loading="magazineDeleteLoading == mag.id"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="newMagazinesDialog">
      <v-card tile>
        <v-toolbar color="primary" dark>
          New Magazine
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newMagazinesDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container style="max-width: 1400px !important">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newMagazine.name"
                  label="Magazine Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="newMagazine.releaseDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newMagazine.releaseDate"
                      label="Release Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newMagazine.releaseDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu2.save(newMagazine.releaseDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <h1>Thumbnail</h1>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  :rules="imageUploadRules"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="Choose an Image"
                  prepend-icon="mdi-camera"
                  label="Image"
                  v-model="newThumbnailImage"
                  @change="updateNewPreviewImage('Thumbnail')"
                ></v-file-input>
                <v-img
                  v-if="newThumbnailImagePreview"
                  class="white--text"
                  contain
                  style="margin: auto; border: 1px solid black"
                  height="300px"
                  width="250"
                  :aspect-ratio="6 / 5"
                  :src="newThumbnailImagePreview"
                ></v-img>
              </v-col>
              <v-col cols="12">
                <h1>Magazine PDF</h1>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  :rules="imageUploadRules"
                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                  placeholder="Choose a PDF"
                  prepend-icon="mdi-camera"
                  label="PDF"
                  v-model="newPDF"
                  @change="updateNewPreviewImage('PDF')"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            color="primary"
            :loading="newMagazineLoading"
            @click="createNewMagazine()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editMagazine" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Magazine #{{ selectedMagazine.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="editMagazine = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" style="text-align: center">
                <h1>Thumbnail</h1>
              </v-col>
              <v-col cols="12">
                <v-card flat>
                  <v-img
                    class="white--text align-end"
                    contain
                    height="300px"
                    :src="`https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/MagazineAssets/${selectedMagazine.id}-Thumbnail.${selectedMagazine.imageExt}?cb=${cb}`"
                  >
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedMagazine.name"
                  label="Magazine Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="selectedMagazine.releaseDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="selectedMagazine.releaseDate"
                      label="Release Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedMagazine.releaseDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(selectedMagazine.releaseDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col style="text-align: center" cols="12">
                <v-btn @click="changeThumbnail()" block dark color="primary">
                  Change Thumbnail
                </v-btn>
              </v-col>
              <v-col style="text-align: center" cols="12" sm="6">
                <v-btn @click="changePDF()" block dark color="primary">
                  Change PDF
                </v-btn>
              </v-col>
              <v-col style="text-align: center" cols="12" sm="6">
                <v-btn
                  @click="viewPDF(selectedMagazine.id)"
                  dark
                  block
                  color="primary"
                >
                  View PDF
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            @click="saveMagazine()"
            color="success"
            :loading="magazineSaveLoading"
          >
            Save Magazine
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadImageDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Upload a {{ uploadFileType }} for {{ selectedMagazine.name }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="uploadImageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  :rules="imageUploadRules"
                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                  :placeholder="`Choose a ${uploadFileType}`"
                  prepend-icon="mdi-camera"
                  :label="uploadFileType"
                  v-model="image"
                  @change="updatePreviewImage"
                ></v-file-input>
                <p v-if="uploadFileType == 'Thumbnail'">
                  We recommend an image of 300x250(Portrait)
                </p>
              </v-col>
              <v-col
                v-if="previewUrl != null && uploadFileType == 'Thumbnail'"
                cols="12"
              >
                <v-img
                  class="white--text"
                  contain
                  style="margin: auto; border: 1px solid black"
                  height="300px"
                  width="250"
                  :aspect-ratio="6 / 5"
                  :src="previewUrl"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            color="success"
            :loading="imageUploadLoading"
            @click="uploadImage()"
            >Upload {{ uploadFileType }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import moment from "moment";

  export default {
    components: { AppBar, expandedToolbar },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "magazinesIndustrial",
        "magazinesIndustrialLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // Image Upload
      uploadImageDialog: false,
      imageUploadRules: [
        (value) =>
          !value ||
          value.size < 40000000 ||
          "Avatar size should be less than 40 MB!",
      ],
      image: null,
      previewUrl: null,
      imageUploadLoading: false,
      uploadFileType: null,
      search: "",
      editMagazine: false,
      switchStatusLoading: null,
      selectedMagazine: {},
      tab: null,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      cb: null,

      // New magazine
      newMagazinesDialog: false,
      newMagazine: {},
      newThumbnailImage: null,
      newPDF: null,
      newThumbnailImagePreview: false,
      newPDFPreview: false,
      newMagazineLoading: false,

      // Save Magazine
      magazineSaveLoading: false,

      // Delete Magazine
      magazineDeleteLoading: null,

      menu: false,
      menu2: false,
    }),
    mounted() {
      this.$store.dispatch("loadIndustrialMagazines");
      this.cb = this.r();
    },
    methods: {
      magStatusColor(status) {
        let color = "grey";
        switch (status) {
          case "In-Active":
            color = "red";
            break;
          case "Active":
            color = "green";
            break;
          default:
            break;
        }
        return color;
      },
      magazineCardBtnColor(status) {
        let color = "grey";
        switch (status) {
          case "In-Active":
            color = "green";
            break;
          case "Active":
            color = "red";
            break;
          default:
            break;
        }
        return color;
      },
      magazineCardBtnText(status) {
        let text = "grey";
        switch (status) {
          case "In-Active":
            text = "Make Active";
            break;
          case "Active":
            text = "Make In-Active";
            break;
          default:
            break;
        }
        return text;
      },
      switchStatus(mag) {
        this.switchStatusLoading = mag.id;
        if (mag.status != "Active") {
          mag.status = "Active";
        } else {
          mag.status = "In-Active";
        }
        this.$store.dispatch("saveMagazine", mag).then((result) => {
          this.switchStatusLoading = false;
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Magazine has been Updated",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      editDetails(mag) {
        this.selectedMagazine = mag;
        this.editMagazine = true;
      },
      changeThumbnail() {
        this.uploadFileType = "Thumbnail";
        this.uploadImageDialog = true;
      },
      changePDF() {
        this.uploadFileType = "PDF";
        this.uploadImageDialog = true;
      },
      uploadImage() {
        this.imageUploadLoading = true;
        const payload = {
          id: this.selectedMagazine.id,
          type: this.uploadFileType,
          data: this.previewUrl,
        };
        this.$store.dispatch("magazinesUpload", payload).then((result) => {
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Image has been Uploaded",
              type: "success",
              confirmButtonText: "Ok",
            });
            if (this.uploadFileType == "Thumbnail") {
              let ext = this.previewUrl.match(/.*image\/(.*);/);
              this.selectedMagazine.imageExt = ext[1];
            }

            this.imageUploadLoading = false;
            this.uploadImageDialog = false;
            this.cb = this.r();
          } else {
            this.$swal({
              title: "Error",
              text: "Please try again Later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      updatePreviewImage() {
        if (this.image != undefined) {
          var reader = new FileReader();
          reader.readAsDataURL(this.image);
          reader.onload = () => {
            this.previewUrl = reader.result;
          };
        } else {
          this.previewUrl = null;
        }
      },
      updateNewPreviewImage(caller) {
        var reader = new FileReader();
        if (caller == "Thumbnail") {
          if (this.newThumbnailImage != undefined) {
            reader.readAsDataURL(this.newThumbnailImage);
            reader.onload = () => {
              this.newThumbnailImagePreview = reader.result;
            };
          } else {
            this.newThumbnailImagePreview = false;
          }
        } else if (caller == "PDF") {
          if (this.newPDF != undefined) {
            reader.readAsDataURL(this.newPDF);
            reader.onload = () => {
              this.newPDFPreview = reader.result;
            };
          } else {
            this.newPDFPreview = false;
          }
        }
      },
      saveMagazine() {
        let payload = {
          name: this.selectedMagazine.name,
          id: this.selectedMagazine.id,
          releaseDate: this.selectedMagazine.releaseDate,
        };
        this.magazineSaveLoading = true;
        this.$store.dispatch("saveMagazine", payload).then((result) => {
          if (result.Result == "Success") {
            this.magazineSaveLoading = false;
            this.editMagazine = false;
            this.$swal({
              title: "Success",
              text: "The magazine has been saved",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.magazineSaveLoading = false;
            this.$swal({
              title: "Error",
              text: "Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      createNewMagazine() {
        this.newMagazineLoading = true;
        if (
          this.newThumbnailImagePreview != false &&
          this.newPDFPreview != false
        ) {
          this.newMagazine.type = "industrial";
          this.$store.dispatch("newMagazine", this.newMagazine).then((result) => {
            if (result.Result == "Success") {
              let payload = {
                id: result.id,
                type: "Thumbnail",
                data: this.newThumbnailImagePreview,
              };
              this.$store
                .dispatch("magazinesUpload", payload)
                .then((thumbnailResult) => {
                  if (thumbnailResult.Result == "Success") {
                    let payload = {
                      id: result.id,
                      type: "PDF",
                      data: this.newPDFPreview,
                    };
                    this.$store
                      .dispatch("magazinesUpload", payload)
                      .then((pdfResult) => {
                        if (pdfResult.Result == "Success") {
                          this.newMagazinesDialog = false;
                          this.newMagazine = {};
                          this.newThumbnailImage = null;
                          this.newPDF = null;
                          this.newThumbnailImagePreview = false;
                          this.newPDFPreview = false;
                          this.newMagazineLoading = false;
                          this.$store.dispatch("loadIndustrialMagazines");
                          this.$swal({
                            title: "Success",
                            text: "The Magazine has been created",
                            type: "success",
                            confirmButtonText: "Ok",
                          });
                        } else {
                          this.newMagazineLoading = false;
                          this.$swal({
                            title: "Error",
                            text: "There was an issue Uploading the PDF",
                            type: "error",
                            confirmButtonText: "Ok",
                          });
                        }
                      });
                  } else {
                    this.newMagazineLoading = false;
                    this.$swal({
                      title: "Error",
                      text: "There was an issue Uploading the Thumbnail",
                      type: "error",
                      confirmButtonText: "Ok",
                    });
                  }
                });
            } else {
              this.newMagazineLoading = false;
              this.$swal({
                title: "Error!",
                text: "Something went wrong, please try again later",
                type: "error",
                confirmButtonText: "Ok",
              });
            }
          });
        } else {
          this.newMagazineLoading = false;
          this.$swal({
            title: "Whoops!",
            text: "Please upload a Thumbnail and PDF before continuing",
            type: "warning",
            confirmButtonText: "Ok",
          });
        }
      },
      viewPDF(id) {
        window.open(
          `https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/MagazineAssets/${id}-PDF.pdf?cb=${
            this.cb
          }&r=${this.r()}`,
          "_blank"
        );
      },
      r() {
        return Math.random().toString(36).substring(7);
      },
      deleteMagazine(id) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete a Magazine, Are you sure you want to continue?",
          type: "warning",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            let payload = {
              id: id,
            };
            this.magazineDeleteLoading = id;
            this.$store.dispatch("deleteMagazine", payload).then((result) => {
              if (result.Result == "Success") {
                this.magazineDeleteLoading = null;
                this.$swal({
                  title: "Success",
                  text: "The magazine has been deleted",
                  type: "success",
                  confirmButtonText: "Ok",
                });
              } else {
                this.magazineSaveLoading = null;
                this.$swal({
                  title: "Error",
                  text: "Please try again later",
                  type: "error",
                  confirmButtonText: "Ok",
                });
              }
            });
          }
        });
      },
    },
  };
</script>
